import html2canvas from 'html2canvas'
import betterwe from '@/common/app-common.js'
import { Toast } from 'vant'
let creatingPoster //正在生成海报
const shareCopyBtn = 'share-copy-btn'
//分享到微信
const shareWechat = (obj) => {
  betterwe.onAppShare(obj)
}
//默认分享参数
const defaultShareOptions = {
  url: 'https://member3.gymcity.com.cn/#/app-download',
  desc: '上betterWE,让你越吃越美',
  title: 'betterWE星球',
  thumbnail:
    'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e93143f47e6418437ba209310fb2f306.png'
}
/* 分享参数
{
  url：  链接或者是分享的base64链接
  desc：描述
  title：标题
  thumbnail：缩略图
}
*/
const eventObj = {
  //生成图片
  createPoster: function (id, createMore = false) {
    return new Promise((resolve, reject) => {
      if (creatingPoster && !createMore) {
        reject()
        return
      }
      // window.scroll(0,0);
      let dom = document.getElementById(id)
      if (!dom) {
        reject()
        Toast('未获取到分享图')
        return
      }
      creatingPoster = true
      Toast.loading('正在生成图片...')
      html2canvas(dom, {
        backgroundColor: null,
        useCORS: true
      })
        .then((canvas) => {
          Toast.clear()
          Toast('图片已生成')
          resolve(canvas.toDataURL())
        })
        .catch((err) => {
          console.log(err)
          reject()
        })
        .finally(() => {
          creatingPoster = false
        })
    })
  },
  //分享链接到微信好友
  shareLinkToWxFriend: function (options) {
    let shareOptions = Object.assign({}, defaultShareOptions, options)
    let obj = {
      shareType: 1, //分享的类型 1 微信好友 2 微信朋友圈
      contentType: 'url', //分享的数据类型  image 分享图片  url 分享H5链接
      // 分享的数据
      shareData: {
        data: shareOptions.url, //分享的链接
        //分享的数据的格 式
        //contentType为image的情况下, type=base64  表示图片格式是base64   type=url  表示图片格式是链接
        type: 'url',
        desc: shareOptions.desc,
        title: shareOptions.title,
        thumbnail: shareOptions.thumbnail // 分享的缩略图的url
      }
    }
    shareWechat(obj)
  },
  //分享链接到微信朋友圈
  shareLinkToWxCircle: function (options) {
    let shareOptions = Object.assign({}, defaultShareOptions, options)
    let obj = {
      shareType: 2, //分享的类型 1 微信好友 2 微信朋友圈
      contentType: 'url', //分享的数据类型  image 分享图片  url 分享H5链接
      // 分享的数据
      shareData: {
        data: shareOptions.url, //分享的链接
        //分享的数据的格 式
        //contentType为image的情况下, type=base64  表示图片格式是base64   type=url  表示图片格式是链接
        type: 'url',
        desc: shareOptions.desc,
        title: shareOptions.title,
        thumbnail: shareOptions.thumbnail // 分享的缩略图的url
      }
    }
    shareWechat(obj)
  },
  //复制链接到粘贴板
  copyLinkToClipboard: function () {},
  //保存图片到手机
  saveImageToPhone: function (base64Data) {
    if (!base64Data) {
      Toast('保存图片不能为空')
      return
    }
    betterwe.onAppSaveImage({
      data: base64Data, //分享的具体数据
      //分享的数据的格式
      //type=base64  表示图片格式是base64   type=url  表示图片格式是链接
      type: 'base64'
    })
  },
  //保存图片链接到手机
  saveImageUrlToPhone: function (url) {
    if (!url) {
      Toast('保存图片链接不能为空')
      return
    }
    betterwe.onAppSaveImage({
      data: url, //分享的具体数据
      //分享的数据的格式
      //type=base64  表示图片格式是base64   type=url  表示图片格式是链接
      type: 'url'
    })
  },
  shareImageToWxFriend: function (options) {
    let shareOptions = Object.assign({}, defaultShareOptions, options)
    let obj = {
      shareType: 1, //分享的类型 1 微信好友 2 微信朋友圈
      contentType: 'image', //分享的数据类型  image 分享图片  url 分享H5链接
      // 分享的数据
      shareData: {
        data: shareOptions.url, //分享的链接
        //分享的数据的格 式
        //contentType为image的情况下, type=base64  表示图片格式是base64   type=url  表示图片格式是链接
        type: 'base64',
        desc: shareOptions.desc,
        title: shareOptions.title,
        thumbnail: shareOptions.thumbnail // 分享的缩略图的url
      }
    }
    shareWechat(obj)
  },
  shareImageUrlToWxFriend: function (options) {
    let shareOptions = Object.assign({}, defaultShareOptions, options)
    let obj = {
      shareType: 1, //分享的类型 1 微信好友 2 微信朋友圈
      contentType: 'image', //分享的数据类型  image 分享图片  url 分享H5链接
      // 分享的数据
      shareData: {
        data: shareOptions.url, //分享的链接
        //分享的数据的格 式
        //contentType为image的情况下, type=base64  表示图片格式是base64   type=url  表示图片格式是链接
        type: 'url',
        desc: shareOptions.desc,
        title: shareOptions.title,
        thumbnail: shareOptions.thumbnail // 分享的缩略图的url
      }
    }
    shareWechat(obj)
  },
  shareImageToWxCircle: function (options) {
    let shareOptions = Object.assign({}, defaultShareOptions, options)
    let obj = {
      shareType: 2, //分享的类型 1 微信好友 2 微信朋友圈
      contentType: 'image', //分享的数据类型  image 分享图片  url 分享H5链接
      // 分享的数据
      shareData: {
        data: shareOptions.url, //分享的链接
        //分享的数据的格 式
        //contentType为image的情况下, type=base64  表示图片格式是base64   type=url  表示图片格式是链接
        type: 'base64',
        desc: shareOptions.desc,
        title: shareOptions.title,
        thumbnail: shareOptions.thumbnail // 分享的缩略图的url
      }
    }
    shareWechat(obj)
  },
  shareImageUrlToWxCircle: function (options) {
    let shareOptions = Object.assign({}, defaultShareOptions, options)
    let obj = {
      shareType: 2, //分享的类型 1 微信好友 2 微信朋友圈
      contentType: 'image', //分享的数据类型  image 分享图片  url 分享H5链接
      // 分享的数据
      shareData: {
        data: shareOptions.url, //分享的链接
        //分享的数据的格 式
        //contentType为image的情况下, type=base64  表示图片格式是base64   type=url  表示图片格式是链接
        type: 'url',
        desc: shareOptions.desc,
        title: shareOptions.title,
        thumbnail: shareOptions.thumbnail // 分享的缩略图的url
      }
    }
    shareWechat(obj)
  }
}

const defultIcons = [
  {
    icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon2',
    name: '微信好友',
    id: 1
  },
  {
    icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon3',
    name: '朋友圈',
    id: 2
  },
  {
    icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon4',
    name: '复制链接',
    id: 3,
    copy: true,
    className: shareCopyBtn
  }
]
//默认分享图标
const defultShareIcons = [
  {
    icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon5',
    name: '生成分享图',
    id: 1,
    showPoster: true //是否显示海报
  },
  {
    icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon2',
    name: '微信好友',
    id: 2
  },
  {
    icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon3',
    name: '朋友圈',
    id: 3
  },
  {
    icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon4',
    name: '复制链接',
    id: 4,
    copy: true,
    className: shareCopyBtn
  }
]
//分享图片时的图标
const shareImageIcons = [
  {
    icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon1',
    name: '保存到手机',
    id: 5
  },
  {
    icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon2',
    name: '微信好友',
    id: 6
  },
  {
    icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon3',
    name: '朋友圈',
    id: 7
  }
]
export {
  eventObj,
  defultShareIcons,
  shareImageIcons,
  shareCopyBtn,
  defultIcons
}
